<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Favorite Icon</div></div>
    <div class="col-sm-3">
        <div class="form-group">
            <div class="c-form-group__label">
                <label for="favoriteIcon">Select Icon</label>
            </div>
            <ccl-simple-select formId="favoriteIcon"
                               [listOfItems]="iconList['fav']"
                               (valueChange)="iconChange($event, 'favIcon', 'favIconSec', 'fav')"
                               [value]="buttonConfig.favIcon"
                               [bindValue]="'class'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="iconColor">
                    Icon Color
                </label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.favIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="iconColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.favIconColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.favIconColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="favFontSize">Font Size</label></div>
            <ccl-simple-select formId="favFontSize"
                               [listOfItems]="sharedService.fontSizes"
                               (valueChange)="buttonConfig.favIconSize = $event.value"
                               [value]="buttonConfig.favIconSize"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div>
            <div class="c-form-group__label">
                <span>
                    Preview Icon
                </span>
            </div>
            <div class="c-cart-icon-preview">
                <div style="margin-top: 7px;">
                    <i
                            aria-label="Favorite Icon Outline"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.favIconSec"
                            [ngStyle]="{ color: buttonConfig.favIconColor }"
                    ></i>
                    <i
                            aria-label="Favorite Icon Selected"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.favIcon"
                            [ngStyle]="{ color: buttonConfig.favIconColor }"
                    ></i>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- cart icon-->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Cart Icon</div></div>
    <div class="col-sm-3">
        <div class="form-group">
            <div class="c-form-group__label">
                <label for="cartIcon">Select Icon</label>
            </div>
            <ccl-simple-select formId="cartIcon"
                               [listOfItems]="iconList['cart']"
                               (valueChange)="iconChange($event, 'cartIcon', 'cartIconSec', 'cart')"
                               [value]="buttonConfig.cartIcon"
                               [bindValue]="'class'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="cartIconColor">Icon Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="cartIconColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.cartIconColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartIconColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="cartFontSize">Font Size</label></div>
            <ccl-simple-select formId="cartFontSize"
                               [listOfItems]="sharedService.fontSizes"
                               (valueChange)="buttonConfig.cartIconSize = $event.value"
                               [value]="buttonConfig.cartIconSize"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div>
            <div class="c-form-group__label">
                <span>
                    Preview Icon
                </span>
            </div>
            <div class="c-cart-icon-preview">
                <div style="margin-top: 7px;">
                    <i
                            aria-label="Cart Icon"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.cartIcon"
                            [ngStyle]="{ color: buttonConfig.cartIconColor }"
                    ></i>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- exc icon-->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Exclude Icon</div></div>
    <div class="col-sm-3">
        <div class="form-group">
            <div class="c-form-group__label">
                <label for="excludeIcon">Select Icon</label>
            </div>
            <ccl-simple-select formId="excludeIcon"
                               [listOfItems]="iconList['remove']"
                               (valueChange)="iconChange($event, 'excIcon', 'excIconSec', 'remove')"
                               [value]="buttonConfig.excIcon"
                               [bindValue]="'class'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="excludeIconColor"> Icon Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.excIconColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="excludeIconColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.excIconColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.excIconColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="excFontSize">Font Size</label></div>
            <ccl-simple-select formId="excFontSize"
                               [listOfItems]="sharedService.fontSizes"
                               (valueChange)="buttonConfig.excIconSize = $event.value"
                               [value]="buttonConfig.excIconSize"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-3">
        <div>
            <div class="c-form-group__label">
                <span>
                    Preview Icon
                </span>
            </div>
            <div class="c-cart-icon-preview">
                <div style="margin-top: 7px;">
                    <i
                            aria-label="Exclude Icon"
                            class="fa fa-lg"
                            [ngClass]="buttonConfig.excIconSec"
                            [ngStyle]="{ color: buttonConfig.excIconColor }"
                    ></i>
                </div>
            </div>
        </div>
    </div>
</div>
<hr />
<!-- reg icon-->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Registered Label</div></div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regLabel">Label</label></div>
            <input id="regLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.regLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="regLabelColor">Label Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.regColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="regLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.regColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.regColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="regLabelBackgroundColor">Background Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.regBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="regLabelBackgroundColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.regBackground"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.regBackground }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="regFontStyle">Font Style</label></div>
            <ccl-simple-select formId="regFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.regFontStyle = $event.value"
                               [value]="buttonConfig.regFontStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<!-- wait icon-->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Waitlisted Label</div></div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="waitLabel">Label</label></div>
            <input id="waitLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.waitLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="waitLabelColor">Label Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.waitColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="waitLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.waitColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.waitColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="waitLabelBackgroundColor">Background Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.waitBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="waitLabelBackgroundColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.waitBackground"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.waitBackground }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="wlFontStyle">Font Style</label></div>
            <ccl-simple-select formId="wlFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.waitFontStyle = $event.value"
                               [value]="buttonConfig.waitFontStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <!-- <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="expansionStyle">Font size</label></div>
            <ccl-simple-select
                [listOfItems]="sharedService.fontSizes"
                (valueChange)="buttonConfig.waitFontSize = $event.value"
                [value]="buttonConfig.waitFontSize"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div> -->
</div>

<!-- filling fast -->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Filling Fast Label</div></div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="fastLabel">Label</label></div>
            <input id="fastLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.fillingFastLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="percentage">Remaining Percentage</label></div>
            <input id="percentage"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.fillingFastPercent"
                   maxlength="3"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="fastLabelColor">Label Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.fillingFastColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="fastLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.fillingFastColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.fillingFastColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="fillFontStyle">Font Style</label></div>
            <ccl-simple-select formId="fillFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.fillingFastFontStyle = $event.value"
                               [value]="buttonConfig.fillingFastFontStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<!-- Capacity Full Label -->
<div class="row">
    <div class="col col-sm-12"><div class="c-title--subsection ">Capacity Full Label</div></div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="capLabel">Label</label></div>
            <input id="capLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.capacityFullLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="capLabelColor">Label Color</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.capacityFullColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
            >
                <input id="capLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.capacityFullColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.capacityFullColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="capFontStyle">Font Style</label></div>
            <ccl-simple-select formId="capFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.capacityFullFontStyle = $event.value"
                               [value]="buttonConfig.capacityFullFontStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<!-- remove from schedule-->
<div class="row">
    <div class="c-title--subsection col-sm-6 mt-8">Remove from schedule Button</div>
</div>
<div class="row">
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="removeLabel">Label</label></div>
            <input id="removeLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.removeScheduleButtonLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="removeLabelBackground">Background</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.removeScheduleButtonBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="removeLabelBackground"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.removeScheduleButtonBackground"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.removeScheduleButtonBackground }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="removeLabelColor">Font Color </label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.removeScheduleButtonColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="removeLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.removeScheduleButtonColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.removeScheduleButtonColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="remFontStyle">Font Style</label></div>
            <ccl-simple-select formId="remFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.removeScheduleButtonStyle = $event.value"
                               [value]="buttonConfig.removeScheduleButtonStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<!-- add to cart button-->
<div class="row">
    <div class="c-title--subsection col-sm-6" style="margin-top: 8px;">Add to Cart Button</div>
    <div class="col col-sm-6">
        <ccl-toggle-button
                [title]="buttonConfig.enableAddToCartButton ? 'Enabled' : 'Disabled'"
                [isChecked]="buttonConfig.enableAddToCartButton"
                (isCheckedChange)="toggleAddToCartButton($event)"
        >{{ buttonConfig.enableAddToCartButton ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</div>

<!-- add to cart button-->
<div *ngIf="buttonConfig.enableAddToCartButton" class="row">
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="addLabel">Label</label></div>
            <input id="addLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.cartButtonLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="addLabelBackground">Background</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartButtonBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="addLabelBackground"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.cartButtonBackground"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartButtonBackground }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="addLabelColor">Font Color </label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.cartButtonColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="addLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.cartButtonColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': buttonConfig.cartButtonColor }"
                    >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="addFontStyle">Font Style</label></div>
            <ccl-simple-select formId="addFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.cartButtonStyle = $event.value"
                               [value]="buttonConfig.cartButtonStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
<!-- add to calendar button-->
<div class="row">
    <div class="c-title--subsection col-sm-6" style="margin-top: 8px;">Add to Calendar Button</div>
    <div class="col col-sm-6">
        <ccl-toggle-button
                [title]="buttonConfig.enableAddToCalendarButton ? 'Enabled' : 'Disabled'"
                [isChecked]="buttonConfig.enableAddToCalendarButton"
                (isCheckedChange)="toggleAddToCalendarButton($event)"
        >{{ buttonConfig.enableAddToCalendarButton ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</div>

<!-- add to calendar button-->
<div *ngIf="buttonConfig.enableAddToCalendarButton" class="row">
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="addLabel">Label</label></div>
            <input id="addLabel"
                   cclFormInput
                   type="text"
                   class="c-form-group__input c-input--required"
                   [(ngModel)]="buttonConfig.calendarButtonLabel"
                   maxlength="100"
            />
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="addLabelBackground">Background</label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.calendarButtonBackground"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="addLabelBackground"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.calendarButtonBackground"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': buttonConfig.calendarButtonBackground }"
                >&nbsp;</span
                >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="addLabelColor">Font Color </label>
            </div>
            <div
                    class="input-group"
                    [(colorPicker)]="buttonConfig.calendarButtonColor"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'top'"
            >
                <input id="addLabelColor"
                       cclFormInput
                       type="text"
                       [(ngModel)]="buttonConfig.calendarButtonColor"
                       class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': buttonConfig.calendarButtonColor }"
                >&nbsp;</span
                >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="addFontStyle">Font Style</label></div>
            <ccl-simple-select formId="addFontStyle"
                               [listOfItems]="sharedService.fontStyles"
                               (valueChange)="buttonConfig.calendarButtonStyle = $event.value"
                               [value]="buttonConfig.calendarButtonStyle"
                               [bindValue]="'id'"
                               [bindLabel]="'label'"
                               [isClearable]="false"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
